

export const Constants = {
  COMPONENT_OPTIONS_KEY: "nuxtI18n",
  STRATEGIES: {"PREFIX":"prefix","PREFIX_EXCEPT_DEFAULT":"prefix_except_default","PREFIX_AND_DEFAULT":"prefix_and_default","NO_PREFIX":"no_prefix"},
}
export const nuxtOptions = {
  isUniversalMode: true,
  trailingSlash: undefined,
}
export const options = {
  vueI18n: {},
  vueI18nLoader: false,
  locales: [{"name":"Français","code":"fr-ca","iso":"fr-ca","file":"fr-ca.js"},{"name":"Anglais","code":"en-ca","iso":"en-ca","file":"en-ca.js"}],
  defaultLocale: "fr-ca",
  defaultDirection: "ltr",
  routesNameSeparator: "___",
  defaultLocaleRouteNameSuffix: "default",
  strategy: "prefix_except_default",
  lazy: true,
  langDir: "/app/locales",
  rootRedirect: null,
  detectBrowserLanguage: {"alwaysRedirect":false,"cookieCrossOrigin":false,"cookieDomain":null,"cookieKey":"i18n_redirected","cookieSecure":false,"fallbackLocale":"","onlyOnNoPrefix":false,"onlyOnRoot":false,"useCookie":true,"redirectOn":"root"},
  differentDomains: false,
  seo: true,
  baseUrl: "https://www.uapinc.com",
  vuex: {"moduleName":"i18n","syncLocale":false,"syncMessages":false,"syncRouteParams":true},
  parsePages: true,
  pages: {},
  skipSettingLocaleOnNavigate: false,
  beforeLanguageSwitch: () => null,
  onLanguageSwitched: () => null,
  loadLanguagesAsync: true,
  fallbackLocale: "fr-ca",
  normalizedLocales: [{"name":"Français","code":"fr-ca","iso":"fr-ca","file":"fr-ca.js"},{"name":"Anglais","code":"en-ca","iso":"en-ca","file":"en-ca.js"}],
  localeCodes: ["fr-ca","en-ca"],
}

export const localeMessages = {
  'fr-ca.js': () => import('../../locales/fr-ca.js' /* webpackChunkName: "lang-fr-ca.js" */),
  'en-ca.js': () => import('../../locales/en-ca.js' /* webpackChunkName: "lang-en-ca.js" */),
}
